<template>
	<div id="metode-pembayaran-form">
    <!-- begin breadcrumb -->
		<ol class="breadcrumb pull-right">
      <li>
        <router-link :to="{path: '/'}">Home</router-link>
      </li>
      <li>Pembayaran</li>
      <li>
        <router-link :to="{path: '/metode-pembayaran'}">List Metode Pembayaran</router-link>
      </li>
      <li class="active">{{ !$route.query.id ? 'Buat' : 'Update' }} Metode Pembayaran</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">{{ !$route.query.id ? 'Buat' : 'Update' }} Metode Pembayaran</h1>
    <!-- end page-header -->
		<div class="row">
      <div class="col-md-12">
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <h4 class="panel-title">{{ !$route.query.id ? 'Buat' : 'Update' }} Metode Pembayaran</h4>
          </div>
          <div class="panel-body">
						<div class="alert alert-danger fade in m-b-15" v-if="this.errors.length > 0">
              <span class="close" data-dismiss="alert">&times;</span>
              <strong>Terjadi kesalahan!</strong>
              <ul>
                <li v-for="(message, key) in this.errors" v-bind:key="key">{{message}}</li>
              </ul>
            </div>

						<!-- begin form -->
            <form>
              <div class="form-horizontal form-bordered">
                <div class="form-group">
                  <label class="col-md-2 control-label">Section</label>
                  <div class="col-md-8 col-xs-12">
										<select name="" v-model="data.type" id="" class="form-control">
                      <option value="LINKAJA">Link Aja</option>
                      <option value="NFJUARA">By Manual (Transfer NFJuara)</option>
                      <option value="MARKETPLACE">Marketplace</option>
                      <option value="ORGANIZATION">By Pantau</option>
                      <option value="OY_EWALLET">OY! EWALLET</option>
                      <option value="OY_PAYMENT_ROUTING">OY! Payment Routing</option>
                    </select>
									</div>
                </div>
                <div class="form-group">
                  <label v-if="isBankPayment" class="col-md-2 control-label">Nama Bank</label>
                  <label v-else class="col-md-2 control-label">Nama Pembayaran</label>
                  <div class="col-md-8 col-xs-12">
										<input type="text" class="form-control" v-model="data.bank_name">
									</div>
                </div>
                <!-- <div class="form-group" v-if="!isBankPayment">
                  <label class="col-md-2 control-label">Partner</label>
                  <div class="col-md-8 col-xs-12">
										<select name="vendor" id="select-vendor" v-model="data.type" class="form-control">
                      <option value="LINKAJA">LINKAJA (Applink)</option>
                      <option value="MARKETPLACE">MARKETPLACE (Manual)</option>
                    </select>
									</div>
                </div> -->
                <div class="form-group">
                  <label class="col-md-2 control-label">Atas Nama</label>
                  <div class="col-md-8 col-xs-12">
										<input type="text" class="form-control" v-model="data.account_name">
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Nomor Rekening</label>
                  <div class="col-md-8 col-xs-12">
										<input type="number" class="form-control" v-model="data.account_number">
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Deskripsi</label>
                  <div class="col-md-8 col-xs-12">
                    <ckeditor :editor="editor" v-model="data.description" :config="editorConfig"></ckeditor>
                    <br />
                    <span v-if="data.description"><i>({{characterCounter(data.description)}} karakter)</i></span>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Terms</label>
                  <div class="col-md-8 col-xs-12">
                    <ckeditor :editor="editor" v-model="data.terms" :config="editorConfig"></ckeditor>
                    <br />
                    <span v-if="data.terms"><i>({{characterCounter(data.terms)}} karakter)</i></span>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Notes</label>
                  <div class="col-md-8 col-xs-12">
                    <ckeditor :editor="editor" v-model="data.notes" :config="editorConfig"></ckeditor>
                    <br />
                    <span v-if="data.notes"><i>({{characterCounter(data.notes)}} karakter)</i></span>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Fee Percentage</label>
                  <div class="col-md-8 col-xs-12">
										<input type="number" class="form-control" v-model="data.fee_percentage">
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Phone Required</label>
                  <div class="col-md-8 col-xs-12">
										<input type="checkbox" class="form-control" v-model="data.is_phonenumber_required" style="height:20px; width:24px;"><br><br>
                    <!-- <strong>Perlu Nomor Handphone </strong> -->
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Waktu Kadaluarsa Pembelian (Detik)</label>
                  <div class="col-md-8 col-xs-12">
										<input type="number" class="form-control" v-model="data.expiration_time">
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Platform</label>
                  <div class="col-md-8 col-xs-12">
										<select name="" id="" class="form-control" v-model="data.platform">
                      <option value="ALL">All</option>
                      <option value="WEB">Web</option>
                      <option value="ANDROID">Android</option>
                    </select>
									</div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Gambar (Max 1MB)</label>
                  <div class="col-md-8 col-xs-12">
                    <div class="row">
                      <div class="col-md-4" v-if="data.bank_logo">
                        <img class="img-fluid" :src="data.bank_logo" />
                      </div>
                      <div class="col-md-8">
                        <app-imagecropper v-on:finished="handleChangeBankLogo($event)" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Nomor Urut</label>
                  <div class="col-md-8 col-xs-12">
										<input type="number" class="form-control" v-model="data.order_number">
                  </div>
                </div>
								<div class="form-group">
                  <label class="col-md-2 control-label">Status</label>
                  <div class="col-md-8 col-xs-12">
										<select class="form-control" v-model="data.status">
											<option value="">-- Pilih Status --</option>
											<option :value="status.PUBLISH">Publish</option>
											<option :value="status.UNPUBLISH">Unpublish</option>
										</select>
									</div>
                </div>
              </div>
            </form>
						<hr />
            <div class="pull-right">
              <button v-if="!$route.query.id && !$route.query.liveId" type="button" class="btn btn-success pull-right" @click="saveData()">Simpan</button>
              <button v-else type="button" class="btn btn-success pull-right" @click="editData()">Update</button>
            </div>
          </div>
        </div>
      </div>
		</div>
		<app-spinner v-if="isLoading"></app-spinner>
	</div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import SalesService from '@/services/sales.js'
import Spinner from '@/components/plugins/Spinner'
import ImageCropper from '@/components/plugins/ImageCropper'

export default {
  name: 'metode-pembayaran-form',
  components: {
    'app-spinner': Spinner,
    'app-imagecropper': ImageCropper
  },
  data: function () {
    return {
      errors: [],
      queryId: null,
      isLoading: false,
      isBankPayment: true,
      status: {
        PUBLISH: 'PUBLISHED',
        UNPUBLISH: 'UNPUBLISHED'
      },
      selectedBankLogo: null,
      data: {
            "bank_name": "",
            "account_number": "",
            "account_name": "",
            "platform": "",
            "description": "",
            "terms": "",
            "notes": "",
            "expiration_time": null,
            "is_phonenumber_required": false,
            "fee_percentage": null,
            "order_number": null,
            "status": "",
            "type": "",
            "bank_logo": ""
          },
      editor: ClassicEditor,
      editorConfig: {
        toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote', '|', 'outdent', 'indent'],
      }
    }
  },
  mounted: function () {
    if (this.$route.query.id) {
      this.queryId = this.$route.query.id
      this.fetchData()
    }
  },
  watch: {
    // isBankPayment: function (val) {
    //   if (val === false) {
    //     this.data.account_name = ''
    //     this.data.account_number = ''
    //   }
    // },
  },
  methods: {
    fetchData: function () {
      var context = this
      var queryId = this.queryId
      this.isLoading = true

      SalesService.getMetodePembayaranDetail(queryId, function (result) {
        context.isLoading = false
        if (result.success) {
          context.data.bank_name = result.data.bank_name
          context.data.account_name = result.data.account_name
          context.data.account_number = result.data.account_number
          context.data.description = result.data.description
          context.data.bank_logo = result.data.bank_logo
          context.data.status = result.data.status
          context.data.type = result.data.type
          context.data.fee_percentage = result.data.fee_percentage
          context.data.notes = result.data.notes
          context.data.terms = result.data.terms
          context.data.expiration_time = result.data.expiration_time
          context.data.platform = result.data.platform
          context.data.order_number = result.data.order_number
          context.data.is_phonenumber_required = result.data.is_phonenumber_required

          // context.isBankPayment = result.data.type == 'NFJUARA' ? true : false
        } else {
          alert('Terjadi Kesalahan : ' + result.message)
        }
      })
    },
    saveData: function () {
      var data = this.data
      var context = this
      this.isLoading = true
      this.data.fee_percentage = parseFloat(this.data.fee_percentage)
      if (this.validateForm()) {
        SalesService.addMetodePembayaranV2(data, function (result) {
          if (result.success) context.doUploadBankLogo(result.data.id)
          else {
            alert('Terjadi Kesalahan : ' + result.message)
            context.isLoading = false
          }
        })
      } else {
        this.isLoading = false
        $(window).scrollTop(0)
      }
    },
    editData: function () {
      var data = this.data
      var id = this.queryId
      var context = this
      this.isLoading = true

      if (this.validateForm()) {
        SalesService.updateMetodePembayaranV2(id, data, function (result) {
          context.isLoading = false
          if (result.success) context.doUploadBankLogo(id)
          else alert('Terjadi Kesalahan : ' + result.message)
        })
      } else {
        this.isLoading = false
        $(window).scrollTop(0)
      }
    },
    handleChangeBankLogo: function (event) {
      this.selectedBankLogo = event.blob
      this.data.bank_logo = event.url
    },
    doUploadBankLogo: function (id) {
      var context = this
      var bankLogo = this.selectedBankLogo
      var formData = new FormData()

      if (bankLogo) {
        formData.append('name', bankLogo.name)
        formData.append('file', bankLogo)

        SalesService.uploadMetodePembayaranBankLogo(id, formData, function (result) {
          if (result.success) context.$router.push({ path: '/metode-pembayaran' })
          else {
            alert('Gagal Upload Bank Logo : ' + result.message)
            context.isLoading = false
          }
        })
      } else {
        context.$router.push({ path: '/metode-pembayaran' })
      }
    },
    validateForm() {
      // // if(this.isBankPayment) this.data.type = 'NFJUARA'
      // else if (!this.isBankPayment && this.data.type == 'NFJUARA') this.data.type = null

      this.errors = []
      if (!this.data.bank_name) this.errors.push('Nama Bank / Pembayaran wajib diisi')
      // if (!this.data.description) this.errors.push('Deskripsi wajib diisi')

      if (this.data.description) {
        if (this.characterCounter(this.data.description) > 1000) {
          this.errors.push('Deskripsi tidak boleh lebih dari 1000 karakter')
        }
      }
      if (!this.data.bank_logo) this.errors.push('Gambar wajib diisi')
      if (!this.data.platform) this.errors.push('Platform wajib diisi')
      if (!this.data.status) this.errors.push('Status wajib diisi')
      if (!this.data.order_number) this.errors.push('Nomor Urutan wajib diisi')
      if (!this.data.account_number) this.errors.push('Gambar wajib diisi')
      if (!this.data.account_name) this.errors.push('Gambar wajib diisi')
      if (this.selectedBankLogo) {
        if (this.selectedBankLogo.size > 1000000) this.errors.push('Gambar tidak boleh lebih dari 1MB')
      }
      return this.errors.length == 0
    },
    characterCounter: function (text) {
      text = text.replace(/<[^>]*>/g, '')
      text = text.replace(/\&nbsp;/g, ' ')
      return text.length
    },
  }
}
</script>

<style>
.ck-content {
  min-height: 120px;
}
</style>



// WEBPACK FOOTER //
// MetodePembayaranFormV2.vue?7bf68dc9